module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pageLoaded),
      expression: "pageLoaded"
    }],
    staticClass: "flex-content"
  }, [_c('group', {
    attrs: {
      "title": "出货人信息"
    }
  }, [_c('cell', {
    attrs: {
      "title": _vm.info.shipper_id
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('p', [_vm._v("ID: " + _vm._s(_vm.info.shipper_id))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.info.nick_name))])]), _vm._v(" "), _c('img', {
    staticStyle: {
      "border-radius": "25px"
    },
    attrs: {
      "slot": "icon",
      "src": _vm.info.shipper_img,
      "width": "50"
    },
    slot: "icon"
  })])], 1), _vm._v(" "), _c('group', {
    attrs: {
      "title": "提货订单信息"
    }
  }, [_c('cell', {
    attrs: {
      "title": "订单ID",
      "value": _vm.info.order_id
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "总数量",
      "value": ("x " + (_vm.info.quantity))
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "订单状态"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#0F769F"
    },
    attrs: {
      "slot": ""
    },
    slot: "default"
  }, [_vm._v(_vm._s(_vm.info.status_text) + " ")])]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "发起时间",
      "value": _vm.info.create_at
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "操作时间",
      "value": _vm.info.confirm_at
    }
  })], 1), _vm._v(" "), _c('group', [(_vm.info.access) ? _c('x-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.confirm(_vm.info.order_id)
      }
    }
  }, [_vm._v("确认提货")]) : _vm._e(), _vm._v(" "), (_vm.info.access) ? _c('x-button', {
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancel(_vm.info.order_id)
      }
    }
  }, [_vm._v("取消提货")]) : _vm._e(), _vm._v(" "), _c('x-button', {
    attrs: {
      "link": "BACK"
    }
  }, [_vm._v("返回")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69845721"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uc/stockDetail.vue
// module id = 707
// module chunks = 0